<template>
  <div>
    <v-row>
      <v-col>
        <v-card flat class="rounded-card" height="100%">
          <v-card-title></v-card-title>
          <v-card-subtitle>
            <v-row>
              <v-col cols="12" md="6" class="text-left">
                <span class="text-md-subtitle-1 font-weight-bold">JWNET起票件数/回収件数</span>
              </v-col>
              <v-col v-if="isTrialPlan" cols="12" md="6" class="text-right">
                <span class="text-md-subtitle-1 font-weight-bold">今月のデータ送信数：{{ dxe_manifest_count }}件</span>
              </v-col>
            </v-row>
          </v-card-subtitle>
          <v-card-text>
            <v-skeleton-loader
              v-if="!chartData.collections.datasets && !chartData.options.plugins.doughnutlabel"
              height="300"
              type="image"
              loading
              transition="fade-transition"
            >
            </v-skeleton-loader>
            <doughnut-chart
              v-else
              :chart-data="chartData.collections"
              :options="chartData.options"
              :style="myStyles"
            />
          </v-card-text>
          <v-card-text v-if="chartData.collections">
            <div class="text-center text-h4 text--black font-weight-bold">
              <span style="color: #0074BA">{{ collectCount }}</span>/{{ totalCount }}&nbsp;件
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import { mapActions, mapState } from 'vuex'
import DoughnutChart from '../../../../components/DoughnutChart'

export default {
  name: 'DashboardDraftingChart',
  components: {
    DoughnutChart
  },
  mixins: [],
  props: {
  },
  data() {
    return {
      graphicalHeight: 230,
      totalCount: 0,
      collectCount: 0,
      dxe_manifest_count: 0,
      chartData: {
        collections: {
          labels: [''],
          datasets: null,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {enabled: false},
          hover: {mode: null},
          title: {
            display: false,
            text: 'DXE_JWNET起票件数/回収件数',
            fontStyle: 'bold',
            fontSize: 17,
          },
          legend: {
            display: false
          },
          plugins: {
            datalabels: {
              display: true,
              backgroundColor: '#ccc',
              borderRadius: 3,
              font: {
                color: 'red',
                weight: 'bold',
              }
            },
            doughnutlabel: null
          }
        },
      },
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isTrialPlan: 'use_trial_plan',
    }),
    myStyles() {
      return {
        height: `${this.graphicalHeight}px`,
        position: 'relative'
      }
    }
  },
  watch: {},
  created() {
    this.buildChartData()
  },
  methods: {
    ...mapActions('DriverDashboardDrafting', {
      fetchDrafting: 'index'
    }),
    buildChartData () {
      this.fetchDrafting().then((content) => {
        this.chartData.collections.datasets = content.datasets
        this.chartData.options.plugins.doughnutlabel = content.doughnut_labels
        this.totalCount = content.total_count
        this.collectCount = content.collect_count
        this.dxe_manifest_count = content.dxe_manifest_count
      })

      // this.chartData.collections.datasets = [{
      //   borderWidth: 1,
      //   backgroundColor: ["#0074BA", "#EEEEEE"],
      //   hoverBackgroundColor: ["#0074BA", "#AAAAAA"],
      //   hoverBorderColor: ["#0074BA", "#ffffff"],
      //   data: [20, 80]
      // }]
      // this.chartData.options.plugins.doughnutlabel = {
      //   labels: [
      //     {
      //       text: '10/22〜11/22',
      //       font: {
      //         size: 12,
      //         weight: ''
      //       }
      //     },
      //     {
      //       text: '77%',
      //       font: {
      //         size: 30,
      //         weight: 'bold'
      //       }
      //     },
      //     {
      //       text: '↑ 5%',
      //       color: '#3CBF91',
      //       font: {
      //         size: 20,
      //         weight: 'bold',
      //       }
      //     }
      //   ]
      // }

    }
  }
}
</script>

<style scoped lang="scss">

</style>
